import React from 'react';
import Modal from '../common/Modal';

const MetadataViewer = (props) => {
  const { displayValue, metadata, viewMeta, setViewMeta } = props;
  // TODO: include Calendar Event data in this component if present

  const handleClick = (e) => {
    setViewMeta(false);
  };

  return (
    <Modal title='metadata-viewer' show={viewMeta} onClose={handleClick}>
      <header>
        <h3>Metadata for: {displayValue}</h3>
      </header>

      <div className='content'>
        <ul>
          {metadata.map((meta) => {
            return (
              <li key={meta.entry.id}>
                <h4>{meta.entry.title}</h4>
                <p>{meta.content.description}</p>
              </li>
            );
          })}
        </ul>

        <div className='controls'>
          <button onClick={handleClick} className='blue'>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MetadataViewer;
